import React, { FC, useState } from 'react'
import { useEffectOnce } from 'react-use'
import { Tab, Tabs } from 'transfix-ui'
import { InboundParserDocument } from './InboundParserDocument'
import { getDocumentConversionDocs, getElementConversionDocs, getJSONSchemaDocs } from './api'
import { useMarkdown } from './hooks/useMarkdown'

interface IDocumentationProps {}

const SIDEBAR_TABS = {
  documentConversionDocs: 'Document Conversion Docs',
  elementConversionDocs: 'Element Conversion Docs',
  jsonSchemaDocs: 'JSON Schema Docs',
}

export const Documentation: FC<IDocumentationProps> = () => {
  const { markdown: elementConversionDocs, setMarkdown: setElementConversionDocs } = useMarkdown()
  const { markdown: documentConversionDocs, setMarkdown: setDocumentConversionDocs } = useMarkdown()
  const { markdown: jsonSchemaDocs, setMarkdown: setJsonSchemaDocs } = useMarkdown()
  const [tabState, setTabState] = useState(SIDEBAR_TABS.documentConversionDocs)

  const fetchElementConversionDocs = async () => {
    const response = await getElementConversionDocs()
    setElementConversionDocs(response)
  }

  const fetchDocumentConversionDocs = async () => {
    const response = await getDocumentConversionDocs()
    setDocumentConversionDocs(response)
  }

  const fetchJSONSchemaDocs = async () => {
    const response = await getJSONSchemaDocs()
    setJsonSchemaDocs(response)
  }

  useEffectOnce(() => {
    fetchDocumentConversionDocs()
    fetchElementConversionDocs()
    fetchJSONSchemaDocs()
  })

  return (
    <Tabs value={tabState} onChange={setTabState}>
      <Tab label='Document Conversion Docs' value={SIDEBAR_TABS.documentConversionDocs}>
        <InboundParserDocument markdown={documentConversionDocs?.markdown || 'Loading ...'} />
      </Tab>
      <Tab label='Element Conversion Docs' value={SIDEBAR_TABS.elementConversionDocs}>
        <InboundParserDocument markdown={elementConversionDocs?.markdown || 'Loading ...'} />
      </Tab>
      <Tab label='JSON Schema Docs' value={SIDEBAR_TABS.jsonSchemaDocs}>
        <InboundParserDocument markdown={jsonSchemaDocs?.markdown || 'Loading ...'} />
      </Tab>
    </Tabs>
  )
}
